import * as Yup from "yup";

export const locationValidationSchema = Yup.object({
	locations: Yup.array()
		.of(
			Yup.object({
				address: Yup.string().required("Address is required"),
				city: Yup.string().required("City is required"),
				state: Yup.string().required("State is required"),
				postcode: Yup.number()
					.typeError("Postcode must be a number")
					.required("Postcode is required"),
				local_govt_association_id: Yup.number()
					.typeError("LGA is required")
					.required("LGA is required"),
			})
		)
		.min(1)
		.test(
			"same-state",
			"All addresses must be from the same state",
			(locs) => {
				if (!locs || locs.length <= 1) return true;
				return locs.every((l) => l.state === locs[0]?.state);
			}
		),
});
